import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'

import { toggleSwitch } from '../../actions/index'

import Logo from './logo.js'

import Burger from '@animated-burgers/burger-arrow' 
import '@animated-burgers/burger-arrow/dist/styles.css' 
import { ToggleActions } from '../../constants/constants.js';
import BackButton from './backButton.js';

class MainCardHeader extends React.Component {
    
    handleClick = () => {
        this.props.toggleSwitch(ToggleActions.MENU)
    }
    
    render() {
        return(
            <div>
                <div className="d-flex flex-row justify-content-between card-section top-of-card card-subcolor">
                    <BackButton/>
                    <div className="right-layout">
                        <Burger
                            isOpen={ this.props.menu }
                            direction="up"
                            onClick={ this.handleClick }/>
                    </div>
                </div>
            </div>
        );
    } 
}

function mapStateToProps( state ){
    return {
    	menu: state.switches.menu,
    }
}


function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        toggleSwitch : toggleSwitch
    }, dispatch)
}


export default connect(mapStateToProps, matchDispatchToProps)(MainCardHeader);